import { Icon } from "UIPalette/Icon/Icon";
import { ReactElement } from "react";
import { ReactComponent as RightChevron } from "shared/assets/Icons/right.svg";

export type CardBodyProps = {
  title?: string;
  description?: string | ReactElement;
  showChevron: boolean;
  icon?: ReactElement;
  iconBackgroundColour?: string;
  iconForegroundColour?: string;
};

export const CardBody = ({ title, icon, description, showChevron, iconBackgroundColour, iconForegroundColour }: CardBodyProps) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        {title && !title.isNullOrEmpty() && <h2 className="!p-0 line-clamp-1">{title}</h2>}
        {showChevron ? <RightChevron className="shrink-0 w-4 text-navy-blue" /> : null}
      </div>
      {(!!description || !!icon) && (
        <div className="flex items-center h-full gap-4">
          {icon && <Icon icon={icon} bgColour={iconBackgroundColour} fgColour={iconForegroundColour} hasDropShadow={false} />}
          {description && <p className="w-full">{description}</p>}
        </div>
      )}
    </div>
  );
};

CardBody.defaultProps = { title: "", showChevron: true };
